import { version } from '../../package.json';

export const service = {
  id: 'threedicom-mobile-viewer',
  name: '3DICOM Mobile Viewer',
  version: version,
};
